import { createFileRoute } from '@tanstack/react-router'
import { PublicCancelPage } from '../../modules/bookings/public-manage-booking'

export const Route = createFileRoute('/booking/$id/cancel')({
  component: CancelRoute,
})

function CancelRoute() {
  const { id } = Route.useParams()
  return <PublicCancelPage bookingId={id} />
}
